import type { LoanTransaction } from '@coreledger/shared-types';
import { api } from './client';
import type { PaginationMeta } from './invoices';

export interface Paginated<T> { data: T[]; meta: PaginationMeta }

export interface LoanTransactionListFilter {
  type?: string;
  loanAccountId?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const loanTransactionsApi = {
  list: (page = 1, limit = 50, filter: LoanTransactionListFilter = {}) => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (filter.type) params.set('type', filter.type);
    if (filter.loanAccountId) params.set('loanAccountId', filter.loanAccountId);
    if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
    if (filter.dateTo) params.set('dateTo', filter.dateTo);
    return api.get<Paginated<LoanTransaction>>(`/loan-transactions?${params.toString()}`);
  },
  create: (data: Partial<LoanTransaction>) => api.post<LoanTransaction>('/loan-transactions', data),
  update: (id: string, data: Partial<LoanTransaction>) => api.patch<LoanTransaction>(`/loan-transactions/${id}`, data),
  delete: (id: string) => api.delete<void>(`/loan-transactions/${id}`),
};
